import { ReactElement } from 'react'

import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { Icon } from 'components/core'
import { theme } from 'styles/theme'
import { RootReduxState } from 'types'

import { NavBadge } from './NavBadge'
import { NavButton } from './NavButton'

interface AlertsNavItemProps {
    onClick: () => void
}

export const AlertsNavItem = ({
    onClick,
}: AlertsNavItemProps): ReactElement | null => {
    const { t } = useTranslation('common')

    const triggeredAlerts = useSelector(
        (state: RootReduxState) => state.ui.app.triggeredAlerts.results
    )

    const unreadAlerts = triggeredAlerts.filter(
        (alert) => alert.status === 'unread'
    )

    return (
        <NavButton onClick={onClick} tooltipText={t('common:alerts', 'Alerts')}>
            <Icon name="BELL" size={18} />
            {unreadAlerts.length > 0 && (
                <NavBadge
                    count={unreadAlerts.length}
                    color={theme.colors.primary}
                />
            )}
        </NavButton>
    )
}
